import { create_agent } from "@tellescope/ai-agent";
import type { Agent } from "@tellescope/ai-agent";
import type { Session } from "@tellescope/sdk";
import { createGetCompletion } from "../get-completion";
import { buildAnalyticsToolForModel } from "../tools/analytics-tool-builder";
import { enduserAnalyticsSchema } from "../schemas";

/**
 * Create an analytics agent with enduser tool.
 *
 * @param session - Tellescope SDK session
 * @returns Configured analytics agent
 */
export const createAnalyticsAgent = (session: Session): Agent => {
  const getCompletion = createGetCompletion(session);

  const enduserTool = buildAnalyticsToolForModel("endusers", enduserAnalyticsSchema, session);

  return create_agent({
    name: "analytics-agent",
    selectionPrompt:
      "Analyze and query data about patients (endusers). " +
      "Use this agent when the user asks analytical questions, wants statistics, or needs to aggregate data.",
    tools: [enduserTool],
    getCompletion,
  });
};
